import { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { authApi } from "@/lib/auth";
import { LogoMark } from "@/components/layout/Navbar";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [checking, setChecking] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    authApi.me()
      .then((user) => navigate("/admin/dashboard", { state: { user }, replace: true }))
      .catch(() => setChecking(false));
  }, [navigate]);

  const signIn = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <main className="min-h-screen flex items-center justify-center px-6 bg-void" data-testid="admin-login">
      <div className="w-full max-w-sm bg-card-dark border hairline rounded-md p-10 text-center grain relative">
        <div className="flex justify-center mb-6"><LogoMark /></div>
        <h1 className="font-display font-bold tracking-[0.18em] text-sm mb-2">FAIRLUME ADMIN</h1>
        <p className="text-muted-green text-xs mb-8">Private lead &amp; sales dashboard</p>
        {error && <p className="text-red-400 text-xs mb-4" data-testid="admin-login-error">{error}</p>}
        <button
          data-testid="admin-google-signin-btn"
          onClick={signIn}
          disabled={checking}
          className="w-full inline-flex items-center justify-center gap-3 bg-white text-[#101214] font-semibold text-sm px-6 py-3.5 rounded-sm hover:bg-[#A7D7A0] transition-colors duration-300 disabled:opacity-50"
        >
          <svg width="16" height="16" viewBox="0 0 24 24" aria-hidden="true">
            <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.27-4.74 3.27-8.1z"/>
            <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84A11 11 0 0 0 12 23z"/>
            <path fill="#FBBC05" d="M5.84 14.1a6.6 6.6 0 0 1 0-4.2V7.06H2.18a11 11 0 0 0 0 9.88l3.66-2.84z"/>
            <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15A11 11 0 0 0 2.18 7.06l3.66 2.84C6.71 7.31 9.14 5.38 12 5.38z"/>
          </svg>
          {checking ? "Checking session…" : "Sign in with Google"}
        </button>
        <Link to="/" className="block mt-6 text-xs text-white/30 hover:text-white/60 transition-colors" data-testid="admin-back-to-site">
          Back to fairlume.com
        </Link>
      </div>
    </main>
  );
}
